import React, { useState } from 'react';
import { ViewUser } from './ViewUser';
import { UpdateUser } from './UpdateUser';
import { AccessPermission } from './AccessPermission';
import { DeleteUsers } from './DeleteUsers';
import { ResetUserPasswords } from './ResetUserPasswords';
import { IManageUsersListRow } from './models';

type Props = {
  closeMenu?: () => void;
  rowId?: number;
  openCloseState: { open: boolean; id: number | null };
  listRows: IManageUsersListRow[];
  canResetPasswords: boolean;
};

export const ManageUsersDropdownOptions: React.FC<Props> = ({
  closeMenu,
  rowId,
  openCloseState,
  listRows,
  canResetPasswords,
}) => {
  const [openViewPopup, setOpenViewPopup] = useState<boolean>(false);
  const [openUpdatePopup, setOpenUpdatePopup] = useState<boolean>(false);
  const [openAccessPopup, setOpenAccessPopup] = useState<boolean>(false);
  const [openDeletePopup, setOpenDeletePopup] = useState<boolean>(false);
  const [openResetPopup, setOpenResetPopup] = useState<boolean>(false);

  return (
    <React.Fragment>
      {openCloseState.open && openCloseState.id === rowId && (
        <div className="RowOptionsMenuContainer">
          {rowId && closeMenu && (
            <div className="ItemsContainer">
              {/* View User */}
              <div
                className="Item"
                onClick={() => {
                  closeMenu();
                  setOpenViewPopup(true);
                }}
              >
                <span>View User</span>
              </div>

              {/* Update User */}
              <div
                className="Item"
                onClick={() => {
                  closeMenu();
                  setOpenUpdatePopup(true);
                }}
              >
                <span>Update User</span>
              </div>

              {/* Access Permission */}
              {/* <div
                className="Item"
                onClick={() => {
                  closeMenu();
                  setOpenAccessPopup(true);
                }}
              >
                <span>Access Permission</span>
              </div> */}

              {/* Reset password */}
              {canResetPasswords && (
                <div
                  className="Item"
                  onClick={() => {
                    closeMenu();
                    setOpenResetPopup(true);
                  }}
                >
                  <span>Reset Password</span>
                </div>
              )}

              {/* Delete user */}
              <div
                className="Item"
                onClick={() => {
                  closeMenu();
                  setOpenDeletePopup(true);
                }}
              >
                <span>Delete User</span>
              </div>
            </div>
          )}
        </div>
      )}

      {/* View User Panel  */}
      {openViewPopup && rowId && (
        <ViewUser
          panelOpen={openViewPopup}
          togglePanelOpen={setOpenViewPopup}
          id={rowId}
        />
      )}

      {/* Update User Panel  */}
      {openUpdatePopup && rowId && (
        <UpdateUser
          panelOpen={openUpdatePopup}
          togglePanelOpen={setOpenUpdatePopup}
          id={rowId}
        />
      )}
      {/* Access Permission Panel  */}
      {openAccessPopup && rowId && (
        <AccessPermission
          panelOpen={openAccessPopup}
          togglePanelOpen={setOpenAccessPopup}
          id={rowId}
        />
      )}

      {/* Delete User Modal  */}
      {openDeletePopup && rowId && (
        <DeleteUsers
          panelOpen={openDeletePopup}
          togglePanelOpen={setOpenDeletePopup}
          addPluralTxt={false}
          ids={[rowId]}
        />
      )}

      {/* Reset Password Modal  */}
      {openResetPopup && rowId && (
        <ResetUserPasswords
          panelOpen={openResetPopup}
          togglePanelOpen={setOpenResetPopup}
          ids={[rowId]}
          listRows={listRows}
        />
      )}
    </React.Fragment>
  );
};
